
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from 'next/head';
import clsxm from '@/lib/clsxm';
import { tone } from '@/components/agents/primitives';
import Footer from '@/components/layout/Footer';
import Seo from '@/components/Seo';
import { ORGANIZATION_SAME_AS } from '@/components/StructuredData';
import { VENUE } from '@/components/workshops/kit';
import WorkshopsAudience from '@/components/workshops/WorkshopsAudience';
import WorkshopsConcerns from '@/components/workshops/WorkshopsConcerns';
import WorkshopsContact from '@/components/workshops/WorkshopsContact';
import WorkshopsCurriculum from '@/components/workshops/WorkshopsCurriculum';
import WorkshopsFaq from '@/components/workshops/WorkshopsFaq';
import WorkshopsFinalCta from '@/components/workshops/WorkshopsFinalCta';
import WorkshopsGallery from '@/components/workshops/WorkshopsGallery';
import WorkshopsHero from '@/components/workshops/WorkshopsHero';
import WorkshopsSession from '@/components/workshops/WorkshopsSession';
import WorkshopsShowcase from '@/components/workshops/WorkshopsShowcase';
import WorkshopsTrainers from '@/components/workshops/WorkshopsTrainers';
const DESCRIPTION = 'Hands-on AI workshops in Singapore for business owners and teams, led by the founders of Easy-Peasy.AI. Learn AI agents, content, image and video tools.';
// The workshop as a course, instead of the site's generic product schema.
const COURSE_JSON_LD = {
    '@context': 'https://schema.org',
    '@type': 'Course',
    name: 'How To Make AI Work For You',
    description: DESCRIPTION,
    url: 'https://easy-peasy.ai/ai-workshops',
    inLanguage: 'en',
    provider: {
        '@type': 'Organization',
        name: 'Easy-Peasy.AI',
        url: 'https://easy-peasy.ai',
        sameAs: ORGANIZATION_SAME_AS,
    },
    hasCourseInstance: {
        '@type': 'CourseInstance',
        courseMode: 'Onsite',
        courseWorkload: 'PT3H',
        location: {
            '@type': 'Place',
            name: VENUE.name,
            address: {
                '@type': 'PostalAddress',
                streetAddress: '18 Cross Street, #02-101',
                postalCode: '048423',
                addressLocality: 'Singapore',
                addressCountry: 'SG',
            },
        },
        instructor: [
            { '@type': 'Person', name: 'Marianna Olefyrenko' },
            { '@type': 'Person', name: 'Dmytro Olefyrenko' },
        ],
    },
};
/*
 * In-person AI workshops in Singapore (English only: the localized URLs
 * redirect here). Every image comes from R2, served as-is.
 */
export default function AIWorkshops() {
    return (<main className={clsxm('relative overflow-x-clip', tone.page)}>
      <Seo templateTitle='AI Workshop in Singapore: Generative and Agentic AI' description={DESCRIPTION} image={`https://easy-peasy.ai/api/og-template?title=${encodeURIComponent('AI Workshops in Singapore')}`} structuredData={false}/>
      <Head>
        <script type='application/ld+json' 
    // Static, server-built JSON: nothing user-supplied goes in here.
    dangerouslySetInnerHTML={{ __html: JSON.stringify(COURSE_JSON_LD) }}/>
      </Head>
      <WorkshopsHero />
      <WorkshopsConcerns />
      <WorkshopsAudience />
      <WorkshopsCurriculum />
      <WorkshopsShowcase />
      <WorkshopsSession />
      <WorkshopsTrainers />
      <WorkshopsGallery />
      <WorkshopsContact />
      <WorkshopsFaq />
      <WorkshopsFinalCta />
      <Footer />
    </main>);
}

    async function __Next_Translate__getStaticProps__1a11b03d3aa__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-workshops',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a11b03d3aa__ as getStaticProps }
  